import React, { useEffect, useState } from "react";

import { observer } from "mobx-react";
import { Col, Row, Form } from "react-bootstrap";
import moment from "moment";

import { BottomsheetDropdown, DatepickerModal, CustomCheckbox, DeathCoverPriceComponent, ChangeProductSection } from "components";
import AmountCalculation from "../../optimization-card/amount-calculation/AmountCalculation";
import DeathCoverGraphSlider from "../../death-cover-graph-slider/DeathCoverGraphSlider";
import AdditionalRiderBenifitsCard from "components/ui/additional-rider-benifits-card/AdditionalRiderBenifitsCard";
import Utils from "./utils";
import AdditionalCards from "./component/addtional-cards/AdditionalCards";
import fetchIncomeLabelBasedOnNeed from "utils/fetchIncomeLabelBasedOnNeed";
import deathCoverPriceLabelFunction from "utils/deathCoverPriceLabelFunction";
import ViewBonusHistoryConstant from "constants/ViewBonusHistoryConstant";
import ViewBonusHistoryButton from "components/ui/view-bonus-history/ViewBonusHistoryButton";

const TotalProtectPlus = (props) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const { form, data } = props;
  let productData = data.data;
  let biResponse = productData.parsedResponse;
  let firstYearResponse = productData.firstYearResponse;
  let coverLabelBaseOnNeed = fetchIncomeLabelBasedOnNeed(data.cardKey);

  useEffect(() => {
    setShowOverlay(productData.fieldChanged);
  }, [productData.fieldChanged]);

  const onHideOverlay = () => {
    setShowOverlay(false);
  };

  let maritalStatus = form.$("marital-status").value.id;



  return (
    <div className='save-my-children'>
      <Row className='mt-4 mb-3 pb-1'>
        <Col lg={7} className='col-12'>
          <DeathCoverPriceComponent
            firstAmount={firstYearResponse?.SA ? firstYearResponse.SA : productData.bi_request.PR_SA}
            secondAmount={firstYearResponse?.MODAL_PREM}
            thirdAmount='980'
            showAdditionalText={false}
            showSecondColAmount={false}
            // secondAmountLabel={form.$("payment-frequency").value.label}
            secondAmountLabel={deathCoverPriceLabelFunction(form.$("payment-frequency").value.id)}
            firstColTitleText={fetchIncomeLabelBasedOnNeed(data.cardKey)}
            secondColTitleText='Price'
            cardKey={data.cardKey}
            showLoader = {!productData.update_BI && productData.fieldChanged}
          />
        </Col>
      </Row>
      <Row className="align-items-center justify-content-md-between">
        <Col md={4} className='col-12 mt-2 mt-md-0 mb-2'>
          <p className='mb-2 font-size-12 font-weight-light total-premium-container-heading'>{form.$("covid-vaccination-status").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("covid-vaccination-status").label}
            menuList={form.$("covid-vaccination-status").extra.optionList}
            value={form.$("covid-vaccination-status").value}
            onSelect={(value) => form.$("covid-vaccination-status").extra.changeVaccinationStatus(form, value, data)}
          />
        </Col>

        <Col xs={12} md={3} className="mt-2">
          <p className='mb-2 font-size-12 font-weight-light total-premium-container-heading text-center'>{form.$("tobacco-user").label}</p>
          <div className="d-flex justify-content-center">
          {form.$("tobacco-user").options.map((item, index) => {
            return (
              <CustomCheckbox
                key={index}
                className='mr-4'
                isChecked={form.$("tobacco-user").value.id === item.id}
                onChange={() => form.$("tobacco-user").extra.onChange(item, form, data)}
                titleStyle='font-size-14 font-weight-light total-premium-container-heading'
                shape='rounded'
                title={item.label}
                mark='checkmark'
              />
            );
          })}
          </div>
        </Col>

        {/* <Col xs={6} md={4}>
                    AddLifeCover data={data} form={form} /> 
                </Col>*/}
        <Col xs={12} lg={4} className='px-auto mt-4'>
          <div className='d-flex flex-row'>
            <div className="col-4 px-0">
              <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("death-benefit-option").label}</div>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                selectedLabelKey='label'
                bottomsheetTitle={form.$("death-benefit-option").label}
                menuList={form.$("death-benefit-option").extra.optionList}
                value={form.$("death-benefit-option").value}
                onSelect={(value) => form.$("death-benefit-option").extra.onDeathBenefitOption(value, form, data)}
                disabled=''
              />
            </div>
            {(form.$("death-benefit-option").value?.id === 33 || form.$("death-benefit-option").value?.id === 35) && (
              <div className='mb-3 col-5 col-lg-4 pl-1 pr-0'>
                <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("payout-option").label}</div>
                <BottomsheetDropdown
                  dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                  menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                  menuItemStyle='d-flex justify-content-between align-items-center'
                  selectedLabelKey='label'
                  bottomsheetTitle={form.$("payout-option").label}
                  menuList={form.$("payout-option").extra.optionList}
                  value={form.$("payout-option").value}
                  onSelect={(value) => form.$("payout-option").extra.onChangePayoutOption(value, form, data)}
                  disabled=''
                />
              </div>
            )}
            {(form.$("death-benefit-option").value?.id === 34 || form.$("death-benefit-option").value?.id === 35) && (
              <div className='mb-3 col-3 pl-1'>
                <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("payout-period").label}</div>
                <BottomsheetDropdown
                  dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                  menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                  menuItemStyle='d-flex justify-content-between align-items-center'
                  selectedLabelKey='label'
                  bottomsheetTitle={form.$("payout-period").label}
                  menuList={form.$("payout-period").extra.optionList}
                  value={form.$("payout-period").value}
                  onSelect={(value) => form.$("payout-period").extra.onChangePayoutPeriod(value, form, data)}
                  disabled=''
                />
              </div>
            )}
          </div>
        </Col>
        </Row>
        <Row>
        <Col xs={12} md={12} className='mt-3 mt-md-0'>
          <ChangeProductSection
            productName={productData.product_name || "TPP"}
            familyProductId={productData.family_product_id}
            cardName={coverLabelBaseOnNeed}
            changeProductList={productData.changeProductList}
            productData={data}
            form={form}
          />
        </Col>
        

        <Col md={12} className='col-12 mt-2 mt-md-0'>
          <DeathCoverGraphSlider
            productTitle='Total Protect Plus'
            openChangeReasonModal={false}
            onIncomeChange={() => {}}
            onPremiumChange={form.$("premium").onChange}
            productID={productData.product_id}
            productData={productData}
            income_value={form.$("income").value}
            premium_value={form.$("premium").value}
            showOverlay={showOverlay}
            hideOverLay={onHideOverlay}
            onClick={() => form.$("premium").extra.calculatePremium(form, data)}
            data=''
            cardKey={data.cardKey}
            isIncomeFieldDisable={form.$("premium").disabled}
            premiumFreq={form.$("payment-frequency").value.label}
            formRef={form}
            recommendedPremium={productData?.recommended_premium}
            recommendedTargetValue={productData?.recommended_sum_assured}
          />
        </Col>
      </Row>
      <Row className='mt-2 mt-md-4'>
        <Col md={6} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("policy-term").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("policy-term").label}
            menuList={form.$("policy-term").extra.optionList}
            value={form.$("policy-term").value}
            onSelect={(e) => form.$("policy-term").extra.onChangePolicyTerm(e, form, data)}
            disabled={false}
          />
          {/* </div> */}
        </Col>
        <Col md={6} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("premium-term").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("premium-term").label}
            menuList={form.$("premium-term").extra.optionList}
            value={form.$("premium-term").value}
            disabled={form.$("premium-term").disabled}
            onSelect={(e) => form.$("premium-term").extra.onChangePremiumTerm(e, form, data)}
          />
          {/* </div> */}
        </Col>
        <Col md={4} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("payment-frequency").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("payment-frequency").label}
            menuList={form.$("payment-frequency").extra.optionList}
            value={form.$("payment-frequency").value}
            onSelect={form.$("payment-frequency").onChange}
            disabled=''
          />
          {/* </div> */}
        </Col>
        <Col md={4} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("underwriting-status").label}</div>
          <BottomsheetDropdown
            ddropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("underwriting-status").label}
            menuList={form.$("underwriting-status").extra.optionList}
            value={form.$("underwriting-status").value}
            onSelect={form.$("underwriting-status").onChange}
            disabled={true}
          />
          {/* </div> */}
        </Col>
        <Col md={4} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("marital-status").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("marital-status").label}
            menuList={form.$("marital-status").extra.optionList}
            value={form.$("marital-status").value}
            onSelect={(e) => form.$("marital-status").extra.onChangeMaritalStatus(e, form, data)}
            disabled=''
          />
          {/* </div> */}
        </Col>


        {form.$("better-half-benefit").value && (
          <>

            <Col md={4} className='col-12 mb-3'>
              {/* <div className="shadow p-3 bg-white rounded mt-4 mb-3"> */}
              <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("name-of-spouse").label}</div>
              <Form.Control
                className='font-size-12 font-weight-light text-black product-form-field'
                placeholder={form.$("name-of-spouse").label}
                value={form.$("name-of-spouse").value}
                onChange={(e) => {

                  let updatedValue = e.target.value

                  let NameRegEx = new RegExp("^([A-Za-z '.]{1,30})$")

                  if (NameRegEx.test(updatedValue)) {
                    form.$("name-of-spouse").value = updatedValue
                      } else {
                        updatedValue = form.$("name-of-spouse").value
                        if (updatedValue.length == 1) {
                            updatedValue = ''
                        }
                     }
                      if (updatedValue.length == 1) {
                          updatedValue = updatedValue.toUpperCase()
                      }
                      form.$("name-of-spouse").value = updatedValue
                }}
                onBlur={(e) => form.$("name-of-spouse").extra.onSpouseNameChange(e.target.value, form, data)}
              />
              {/* </div> */}
            </Col>
            <Col md={4} className='col-12 mb-3'>
              {/* <div className="shadow p-3 bg-white rounded mt-4 mb-3"> */}
              <div className='mb-1 font-size-12 font-weight-light total-premium-container-heading'>{form.$("age-of-spouse").label}</div>
              <DatepickerModal
                plain
                value={form.$("age-of-spouse").value}
                textStyle='font-size-12 font-weight-light text-black text-nowrap overflow-hidden txt-overflow'
                onChange={(value) => form.$("age-of-spouse").extra.changeDob(value, form, data)}
                // disabled={form.$('marital-status').value.id == 9}
                minDate={moment().subtract(18, "years").toString()}
              />
              {/* </div> */}
            </Col>
            <Col md={4} className='col-12 mb-3'>
              {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
              <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("gender-of-spouse").label}</div>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                selectedLabelKey='label'
                bottomsheetTitle={form.$("gender-of-spouse").label}
                menuList={form.$("gender-of-spouse").extra.optionList}
                value={form.$("gender-of-spouse").value}
                onSelect={form.$("gender-of-spouse").onChange}
                disabled=''
              />
              {/* </div> */}
            </Col>

            {/* <Col md={4} className='col-12 mb-3'>
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("spouse-tobacco-consumer").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("spouse-tobacco-consumer").label}
            menuList={form.$("spouse-tobacco-consumer").extra.optionList}
            value={form.$("spouse-tobacco-consumer").value}
            onSelect={form.$("spouse-tobacco-consumer").onChange}
            disabled=''
          />
        </Col> */}
          </>
        )}
        <Col md={4} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("plan-option").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("plan-option").label}
            menuList={form.$("plan-option").extra.optionList}
            value={form.$("plan-option").value}
            onSelect={form.$("plan-option").onChange}
            disabled=''
          />
          {/* </div> */}
        </Col>
        {form.$("plan-option").value.id === 5 && (
          <>
            <Col md={4} className='col-12 mb-3'>
              <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("income-payout-start-age").label}</div>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                selectedLabelKey='label'
                bottomsheetTitle={form.$("income-payout-start-age").label}
                menuList={form.$("income-payout-start-age").extra.optionList}
                value={form.$("income-payout-start-age").value}
                onSelect={form.$("income-payout-start-age").onChange}
                disabled=''
              />
            </Col>
            <Col md={4} className='col-12 mb-3'>
              <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("mode-of-income-pay-out").label}</div>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                selectedLabelKey='label'
                bottomsheetTitle={form.$("mode-of-income-pay-out").label}
                menuList={form.$("mode-of-income-pay-out").extra.optionList}
                value={form.$("mode-of-income-pay-out").value}
                onSelect={form.$("mode-of-income-pay-out").onChange}
                disabled=''
              />
            </Col>
            <Col md={4} className='col-12 mb-3'>
              <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("income-pay-out").label}</div>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                selectedLabelKey='label'
                bottomsheetTitle={form.$("income-pay-out").label}
                menuList={form.$("income-pay-out").extra.optionList}
                value={form.$("income-pay-out").value}
                onSelect={form.$("income-pay-out").onChange}
                disabled=''
              />
            </Col>
          </>
        )}
        {form.$("childs-future-protect-benefit").value && (
          <>
            <Col md={4} className='col-12 mb-3'>
              {/* <div className="shadow p-3 bg-white rounded mt-4 mb-3"> */}
              <div className='mb-1 font-size-12 font-weight-light total-premium-container-heading'>{form.$("child-of-life-assured-age").label}</div>
              <DatepickerModal
                plain
                date={form.$("child-of-life-assured-age").value}
                value={form.$("child-of-life-assured-age").value}
                textStyle='font-size-12 font-weight-light text-black text-nowrap overflow-hidden txt-overflow'
                onChange={(value) => form.$("child-of-life-assured-age").extra.onChangeChildAssuredAge(value, form, data)}
                // disabled={form.$('marital-status').value.id == 9}
                minDate={""}
                maxDate={moment().subtract(18, "years").toString()}
              />
              {/* </div> */}
            </Col>
            <Col md={4} className='col-12 mb-3'>
              {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
              <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("additional-sa").label}</div>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                selectedLabelKey='label'
                bottomsheetTitle={form.$("additional-sa").label}
                menuList={form.$("additional-sa").extra.optionList}
                value={form.$("additional-sa").value}
                onSelect={(value) => form.$("additional-sa").extra.onChangeAdditionalSa(value, form, data)}
                disabled=''
              />
              {/* </div> */}
            </Col>
          </>
        )}
      </Row>
      <Row className='mt-4'>
        <Col md={6} className='col-12'>
          <AdditionalCards data={data} form={form} />
        </Col>
        <Col md={6} className='col-12 mt-4 mt-md-0'>
          <AdditionalRiderBenifitsCard data={data} form={form} showCriticalIllness={true} showIncomeBenefit={false} showHospitalityCashBenefit={true} showWOP={true} showPWB={false} />
        </Col>
      </Row>
    </div>
  );
};

export default observer(TotalProtectPlus);
